export default __webpack_public_path__ + "static/media/cover_20240409_01.166857ea.png";